<template>
 <div class="reserve">
  <div class="com-content">
    <img :src="imgList[tmpType-1]" alt="" />
  </div>
 </div>
</template>

<script>
export default {
  props: {
    tmpType: String,
  },

  data () {
    return {
      imgList: [
        'https://img3.quanyou.com.cn/joy/group1/M00/16/1F/rB4ChmMZTA-APgvNAAH7PHBcfXQ418.png',
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/C2/rB8LrmUuAvmAC0aaAAGOGwf2S7E301.png',
         require('@/assets/images/styleTwo/ms.png'),
         require('@/assets/images/styleFour/ms.png'),
         require('@/assets/images/styleFive/ms.png'),
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  .com-content {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
